import { ReactNode } from "react";
import { View } from "./View";

interface IPageBanner {
  // left side
  iconSource?: string;
  pageTitle: string;
  pageSubtitle: string;
  pageDescription: string;

  // right side
  hideLink?: boolean;
  linkTitle?: string;
  linkSubtitle?: string;
  linkButtonText?: string;
  linkButtonUrl?: string;
  linkButtonAction?: () => void;
  linkButtonIcon?: ReactNode;
  linkButtonIconLeft?: boolean;
  linkButtonClassName?: string;
}

export const PageBanner = (props: IPageBanner) => {
  return (
    <View
      iconSource={props.iconSource}
      hideLink={props.hideLink}
      linkTitle={props.linkTitle}
      linkSubtitle={props.linkSubtitle}
      linkButtonText={props.linkButtonText}
      linkButtonUrl={props.linkButtonUrl}
      linkButtonAction={props.linkButtonAction}
      linkButtonIcon={props.linkButtonIcon}
      linkButtonIconLeft={props.linkButtonIconLeft}
      linkButtonClassName={props.linkButtonClassName}
      {...props}
    />
  );
};
